module.exports = __webpack_public_path__ + "img/b7.50f128a1.png";